import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12","key":"svg-0"}],["path",{"d":"M4 4.01c5.333 5.323 10.667 5.32 16 -.01","key":"svg-1"}]]

const IconWashDryHang = createReactComponent('outline', 'wash-dry-hang', 'WashDryHang', __iconNode);

export default IconWashDryHang;